import { fetchGraphql } from '@ori/fetching';
import { getSegmentationHeaders } from '@ori/presentation-http';

import type { GetProductInfoDialogProductsProps } from './types';
import { APP_NAME } from '../../constants';
import type { GetProductsQuery, GetProductsQueryVariables } from '../../models';
import { getProducts } from '../../queries';
import { mapProductsFromGql } from '../mappers';

export const getProductInfoDialogProducts = async (props: GetProductInfoDialogProductsProps) => {
  const { currentLanguage, globalApiUrl, graphqlUrl, productCodes, tenant, token, atpClusterId, customerId } = props;
  const url = new URL('/graphql', graphqlUrl);
  const { products } = await fetchGraphql<GetProductsQuery, GetProductsQueryVariables>({
    query: getProducts,
    url: url.toString(),
    variables: {
      productCodes,
    },
    headers: await getSegmentationHeaders({
      language: currentLanguage,
      globalApiUrl,
      tenant,
      token,
      sourceAppName: APP_NAME,
      atpClusterId,
      customerId,
    }),
  });

  return products ? mapProductsFromGql(products) : [];
};
